module.exports = __webpack_public_path__ + "static/media/csv_en.61250917.docx";